import React, { useState, useEffect } from 'react'
import { useTable, useFilters, useSortBy, usePagination, useGlobalFilter, useAsyncDebounce } from 'react-table'
import { ChevronDown, ChevronUp } from 'react-feather'
import './ReportTable.css'
import queryString from 'query-string'

import { Row, Col, Button, Input, CustomInput } from 'reactstrap'
import useUrlState from '../../hooks/useUrlState'
import { useLocation, useHistory } from 'react-router-dom/cjs/react-router-dom.min'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

// Define a default UI for filtering
function GlobalFilter({ preGlobalFilteredRows, globalFilter = '', setGlobalFilter }) {
    const count = preGlobalFilteredRows.length
    const [inputvalue, setInputValue] = useUrlState('filter', globalFilter)
    const history = useHistory()
    const location = useLocation()

    const onChange = useAsyncDebounce((value) => {
        setGlobalFilter(value || undefined)
    }, 200)

    const resetFilters = () => {
        // Navigate to the current path without query parameters
        window.location.href = `${location.pathname}`;
    }

    return (
        <div className="d-flex align-items-center">
            <div className="mr-2">Filter:</div>
            <input
                className="form-control mr-2"
                defaultValue={inputvalue}
                onChange={(e) => { setInputValue(e.target.value); onChange(e.target.value) }}
                placeholder={`${count} records...`}
            />
            <Button color="primary" size='sm' onClick={resetFilters} className="float-right text-nowrap">
                Reset Filters
            </Button>
        </div>
    )
}

export default function TableContainer({ data, columns, totals, getRowProps = () => ({}), disableFilters = false, defaultSortBy = [] }) {

    let {
        getTableProps,
        getTableBodyProps,
        headers,
        //rows,
        page,
        prepareRow,
        visibleColumns,
        preGlobalFilteredRows,
        setGlobalFilter,
        canPreviousPage,
        canNextPage,
        pageOptions,
        pageCount,
        gotoPage,
        nextPage,
        previousPage,
        setPageSize,
        state: { globalFilter, pageIndex, pageSize },
    } = useTable(
        {
            columns,
            totals,
            data,
            initialState: {
                pageIndex: (!disableFilters && queryString.parse(window.location.search).rTPageIndex) ? Number(queryString.parse(window.location.search).rTPageIndex) : 0,
                sortBy: (!disableFilters && queryString.parse(window.location.search).rTSortId && queryString.parse(window.location.search).rTSortId !== 'false')
                    ? [
                        {
                            id: queryString.parse(window.location.search).rTSortId,
                            desc: queryString.parse(window.location.search).rTSortValue === 'desc' || false,
                        }
                    ]
                    : defaultSortBy,
                pageSize: (!disableFilters && queryString.parse(window.location.search).rTPageSize) ? Number(queryString.parse(window.location.search).rTPageSize) : 100,
                hiddenColumns: columns.map((column) => (column.hide ? column.accessor : column.id)),
                globalFilter: (!disableFilters && queryString.parse(window.location.search).filter) || '',
            },
        },
        useFilters,
        useGlobalFilter,
        useSortBy,
        usePagination
    )
    const [reportTableSortId, setReportTableSortId] = useUrlState('rTSortId', 'test')
    const [reportTableSortValue, setReportTableSortValue] = useUrlState('rTSortValue', 'test')
    const [reportTablePageIndex, setReportTablePageIndex] = useUrlState('rTPageIndex', 0)
    const [reportTablePageSize, setReportTablePageSize] = useUrlState('rTPageSize', 100)
    let location = useLocation()
    // useEffect(() => {
    //     let queryParams = new URLSearchParams(location.search)
    //     let filter = queryParams.get('filter')
    //     setGlobalFilter(filter || '');
    // }, []);


    const onChangeInSelect = (event) => {
        setPageSize(Number(event.target.value))
        if (!disableFilters) {
            setReportTablePageSize(event.target.value)
        }
    }

    const onChangeInInput = (event) => {
        const page = event.target.value ? Number(event.target.value) - 1 : 0
        gotoPage(page)
    }

    // Also have to hide headers. Not sure why the above initialState hiddenColumns wouldn't hide the header, but this did the trick.
    headers = headers.filter((header) => header.hide !== true)


    useEffect(() => {
        if (disableFilters) return;
        // Update the URL with the current sort state
        let sortedHeader = headers.find((header) => header.isSorted)
        let tempSortId = null
        let tempSortValue = null

        if (sortedHeader) {
            tempSortId = sortedHeader.id
            tempSortValue = sortedHeader.isSortedDesc ? 'desc' : 'asc'
        } else {
            tempSortId = 'false'
            tempSortValue = 'false'
        }

        if (tempSortId !== reportTableSortId || tempSortValue !== reportTableSortValue) {
            setReportTableSortId(tempSortId)
            setReportTableSortValue(tempSortValue)
        }
    }, [headers, disableFilters])

    useEffect(() => {
        if (disableFilters) return;
        //update the URL with the current page index
        if (pageIndex !== reportTablePageIndex) {
            setReportTablePageIndex(pageIndex)
        }
    }
        , [pageIndex, disableFilters])
    useEffect(() => {
        if (disableFilters) return;
        //update the URL with the current page size
        if (pageSize !== reportTablePageSize) {
            setReportTablePageSize(pageSize)
        }
    }
        , [pageSize, disableFilters])



    return (
        <div style={{ overflowX: 'scroll' }}>
            <table className="table table-striped table-card table-hover mb-0 text-small" {...getTableProps()}>
                <thead>
                    {!disableFilters && (
                        <tr>
                            <th
                                colSpan={visibleColumns.length}
                                style={{
                                    textAlign: 'left',
                                }}
                            >
                                <GlobalFilter preGlobalFilteredRows={preGlobalFilteredRows} globalFilter={globalFilter} setGlobalFilter={setGlobalFilter} />
                            </th>
                        </tr>
                    )}
                    <tr>
                        {headers.map((column) => (
                            <th {...column.getHeaderProps(column.getSortByToggleProps())}>
                                <span className="float-right">
                                    {column.isSorted ? (
                                        column.isSortedDesc ? (
                                            <>
                                                &nbsp; <ChevronDown size={14} />
                                            </>
                                        ) : (
                                            <>
                                                &nbsp; <ChevronUp size={14} />
                                            </>
                                        )
                                    ) : (
                                        ''
                                    )}
                                </span>
                                {column.render('Header')}
                            </th>
                        ))}
                    </tr>
                </thead>
                <tbody {...getTableBodyProps()}>
                    {/* {rows.map((row, i) => { */}
                    {page.map((row, i) => {
                        prepareRow(row)
                        // console.log(row)
                        return (
                            <tr {...row.getRowProps(getRowProps(row))}>
                                {row.cells.map((cell) => {
                                    // Conditional formatting example
                                    //
                                    // {
                                    //     Header: 'Balance',
                                    //     accessor: 'balance',
                                    //     className: 'w-25',
                                    //     conditionalClassName: (value, row) => {
                                    //         return value < 0 ? 'bg-danger' : 'bg-success'
                                    //     },
                                    //     Cell: ({ cell: { value } }) => {
                                    //         return (
                                    //             <>
                                    //                 <Dollars value={value} />
                                    //             </>
                                    //         )
                                    //     },
                                    // },
                                    return (
                                        <td
                                            {...cell.getCellProps({
                                                className: cell.column.className + (cell.column.conditionalClassName ? ' ' + cell.column.conditionalClassName(cell.value, row.original) : ''),
                                            })}
                                        >
                                            {cell.render('Cell')}
                                        </td>
                                    )
                                })}
                            </tr>
                        )
                    })}
                </tbody>
                {totals && (
                    <tfoot>
                        <tr className="font-weight-bold">
                            <td>Totals</td>
                            {totals.map((total) => {
                                if (total.type === 'number' || total.type === 'int') {
                                    return <td align="right">{Intl.NumberFormat('en-GB').format(total.value)}</td>
                                } else if (total.type === 'dollar' || total.type === 'dollars') {
                                    return <td align="right">${Intl.NumberFormat('en-GB', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(total.value)}</td>
                                } else if (total.type === 'eur') {
                                    return <td align="right">€{Intl.NumberFormat('en-GB', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(total.value)}</td>
                                } else {
                                    return <td align="right">{total.value}</td>
                                }
                            })}
                        </tr>
                    </tfoot>
                )}
            </table>

            {/* // Pagination CSS */}
            <Row className="my-3" style={{ width: '100%', maxWidth: '100%', margin: '0 auto', textAlign: 'center' }}>
                <Col md={3}>
                    <Button color="primary" onClick={() => gotoPage(0)} disabled={!canPreviousPage} className="mx-1">
                        {'<<'}
                    </Button>
                    <Button color="primary" onClick={previousPage} disabled={!canPreviousPage} className="mx-1">
                        {'<'}
                    </Button>
                </Col>
                <Col md={2} style={{ marginTop: 7 }}>
                    Page{' '}
                    <strong>
                        {pageIndex + 1} of {pageOptions.length}
                    </strong>
                </Col>
                <Col md={2}>
                    <Input type="number" min={1} style={{ width: 70 }} max={pageOptions.length} defaultValue={pageIndex + 1} onChange={onChangeInInput} />
                </Col>
                <Col md={2}>
                    <CustomInput type="select" id={pageSize} value={pageSize} onChange={onChangeInSelect}>
                        {[100, 500, 1000].map((pageSize) => (
                            <option key={pageSize} value={pageSize}>
                                Show {pageSize}
                            </option>
                        ))}
                    </CustomInput>
                </Col>
                <Col md={3}>
                    <Button color="primary" onClick={nextPage} disabled={!canNextPage} className="mx-1">
                        {'>'}
                    </Button>
                    <Button color="primary" onClick={() => gotoPage(pageCount - 1)} disabled={!canNextPage} className="mx-1">
                        {'>>'}
                    </Button>
                </Col>
            </Row>
        </div>
    )
}